/**
 * "Ähnliche Produkte" — visually similar products on a product page.
 *
 * Calls the search service's POST /similar with the current product handle:
 * SigLIP 2 image->image similarity over the catalogue's product photos. This is
 * the modality the bench picked for visual matching — R@1 0.833 / R@5 0.933 on
 * held-out photos (engine/search/RICH_DOCUMENT_RESULTS.md §3), ~5x image->text.
 *
 * Distinct from the theme's existing `related-products` / `product-recommendations`
 * sections, which are Shopify's own catalogue-relationship recommendations. This
 * one answers "looks like this", which those cannot.
 *
 * Fails silently and completely: any error, empty result, or missing container
 * leaves the page exactly as it was. A recommendation strip is never worth
 * breaking a product page for.
 *
 * Card rendering is delegated to search-cards.js (window.DubistdaSearch) — see
 * that file for the XSS rules. Do not build markup with innerHTML here.
 */
(function () {
  var K = 4;
  var FETCH_TIMEOUT_MS = 6000; // image similarity is a model call, slower than text

  var TEXT = {
    de: { heading: 'Ähnliche Produkte' },
    en: { heading: 'Similar products' },
  };

  async function run() {
    var api = window.DubistdaSearch;
    if (!api || !api.API_BASE) return; // shared helper missing/not configured — inert

    var container = document.getElementById('VisualSimilar');
    if (!container) return;
    var handle = container.getAttribute('data-handle');
    if (!handle) return;

    var payload = new FormData();
    payload.append('handle', handle);
    payload.append('k', String(K));

    var data;
    try {
      var resp = await api.fetchWithTimeout(api.API_BASE + '/similar', FETCH_TIMEOUT_MS, {
        method: 'POST',
        body: payload,
      });
      // 404 = this product has no indexed image yet (normal for a new product);
      // 503 = image index unavailable. Both mean "no strip", not "error".
      if (!resp.ok) return;
      data = await resp.json();
    } catch (e) {
      console.warn('[visual-similar] service unreachable, no strip rendered', e);
      return;
    }

    var results = (data && data.results) || [];
    if (results.length === 0) return;

    var products = await api.hydrate(results);
    if (products.length === 0) return;

    var lang = api.currentLang();
    var t = TEXT[lang] || TEXT.de;

    var section = document.createElement('div');
    section.className = 'page-width section-template--visual-similar-padding';
    section.style.cssText = 'margin-top:3rem;margin-bottom:3rem;';

    var h2 = document.createElement('h2');
    h2.className = 'title h2';
    h2.textContent = t.heading;
    section.appendChild(h2);

    var ul = document.createElement('ul');
    ul.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
    ul.setAttribute('role', 'list');
    products.forEach(function (p) {
      ul.appendChild(api.buildCard(p));
    });
    section.appendChild(ul);

    container.appendChild(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
